module.exports = __webpack_public_path__ + "static/media/flo2.27117594.png";